import {
  FaPlane,
  FaHotel,
  FaBus,
  FaTrain,
  FaUmbrellaBeach,
  FaCar,
  FaUtensils,
  FaHome
} from 'react-icons/fa';

export const navIconMap = {
  flight: FaPlane,
  flights: FaPlane,
  train: FaTrain,
  trains: FaTrain,
  hotel: FaHotel,
  hotels: FaHotel,
  restaurant: FaUtensils,
  restaurants: FaUtensils,
  bus: FaBus,
  buses: FaBus,
  car: FaCar,
  transfers: FaCar,
  holiday: FaUmbrellaBeach,
  holidays: FaUmbrellaBeach,
  home: FaHome
};

export const getNavIcon = (icon) => navIconMap[icon?.toLowerCase()] || FaPlane;
